var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EditorAutoComplete',{attrs:{"title":"所在城市","value":_vm.value,"remoteMethodCallback":_vm.fetchCitiesRemoteMethod},on:{"clickPickerItem":_vm.clickSinglePickerValue}})
}
var staticRenderFns = []

export { render, staticRenderFns }